import { useEffect, useLayoutEffect } from 'react';

import { useSectors } from '../../context/sectors';
import { isSeniorAnalyst } from '../../hooks/useUserSeniority';
import { useUserSeniority } from '../../queries/seniority';
import { ChildrenProps } from '../../types/common';
import { SectorDataInstance } from './SectorDataProvider.class';

export const SectorDataManager = ({ children }: ChildrenProps) => {
  const { data: seniority } = useUserSeniority();
  const { sectorsQueryData: sectors, setSelectedSectors } = useSectors();

  useLayoutEffect(() => {
    if (seniority && sectors) {
      let filteredSectors = sectors;

      // at start we select all the Themes for Junior, but only active theme for Senior
      if (isSeniorAnalyst(seniority)) {
        filteredSectors = sectors.filter((sector) => sector.isUsersActiveSector);
      }

      // Store the current sector IDs outside the React state
      SectorDataInstance.setSelectedSectorsIds(filteredSectors);
      setSelectedSectors(filteredSectors);
    }
  }, [sectors, seniority, setSelectedSectors]);

  useEffect(
    // we return the unmount effect with cleanup callback for SectorDataInstance
    () => () => {
      SectorDataInstance.clean();
      setSelectedSectors([]);
    },
    [setSelectedSectors],
  );

  return <>{children}</>;
};
